// import React, { useState } from 'react';
// import './ReviewModal.css';

// const ReviewModal = ({ 
//   isOpen, 
//   onClose, 
//   onSubmit, 
//   lawyerName, 
//   appointmentId, 
//   lawyerId, 
//   clientId 
// }) => {
//   const [rating, setRating] = useState(0);
//   const [review, setReview] = useState('');
//   const [isAnonymous, setIsAnonymous] = useState(false);
//   const [consultationQuality, setConsultationQuality] = useState(0);
//   const [communicationQuality, setCommunicationQuality] = useState(0);
//   const [professionalism, setProfessionalism] = useState(0);
//   const [overallExperience, setOverallExperience] = useState(0);
//   const [wouldRecommend, setWouldRecommend] = useState(null);
//   const [isSubmitting, setIsSubmitting] = useState(false);

//   const handleSubmit = async () => {
//     if (rating === 0) {
//       alert('Please provide a rating');
//       return;
//     }

//     setIsSubmitting(true);
//     try {
//       const reviewData = {
//         appointmentId,
//         lawyerId,
//         clientId,
//         rating,
//         review: review.trim() || null,
//         isAnonymous,
//         consultationQuality: consultationQuality || null,
//         communicationQuality: communicationQuality || null,
//         professionalism: professionalism || null,
//         overallExperience: overallExperience || null,
//         wouldRecommend
//       };

//       const response = await fetch('/api/client/submitReview', {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify(reviewData),
//       });

//       const result = await response.json();

//       if (response.ok) {
//         onSubmit(result);
//         handleClose();
//       } else {
//         alert(`Error: ${result.error}`);
//       }
//     } catch (error) {
//       console.error('Error submitting review:', error);
//       alert('Failed to submit review. Please try again.');
//     } finally {
//       setIsSubmitting(false);
//     }
//   };

//   const handleClose = () => {
//     setRating(0);
//     setReview('');
//     setIsAnonymous(false);
//     setConsultationQuality(0);
//     setCommunicationQuality(0);
//     setProfessionalism(0);
//     setOverallExperience(0);
//     setWouldRecommend(null);
//     onClose();
//   };

//   const renderStars = (value, onChange, label) => (
//     <div className="star-rating">
//       <label>{label}</label>
//       <div className="stars">
//         {[1, 2, 3, 4, 5].map((star) => (
//           <button
//             key={star}
//             type="button"
//             className={`star ${star <= value ? 'filled' : ''}`}
//             onClick={() => onChange(star)}
//           >
//             ★
//           </button>
//         ))}
//       </div>
//     </div>
//   );

//   if (!isOpen) return null;

//   return (
//     <div className="review-modal-overlay">
//       <div className="review-modal">
//         <div className="review-modal-header">
//           <h2>Rate Your Consultation</h2>
//           <p>How was your consultation with {lawyerName}?</p>
//         </div>

//         <div className="review-modal-content">
//           {/* Overall Rating */}
//           <div className="rating-section">
//             <h3>Overall Rating</h3>
//             {renderStars(rating, setRating, '')}
//           </div>

//           {/* Detailed Ratings */}
//           <div className="detailed-ratings">
//             <h3>Rate Specific Aspects</h3>
//             {renderStars(consultationQuality, setConsultationQuality, 'Consultation Quality')}
//             {renderStars(communicationQuality, setCommunicationQuality, 'Communication')}
//             {renderStars(professionalism, setProfessionalism, 'Professionalism')}
//             {renderStars(overallExperience, setOverallExperience, 'Overall Experience')}
//           </div>

//           {/* Would Recommend */}
//           <div className="recommendation-section">
//             <h3>Would you recommend this lawyer?</h3>
//             <div className="recommendation-buttons">
//               <button
//                 type="button"
//                 className={`recommend-btn ${wouldRecommend === true ? 'selected' : ''}`}
//                 onClick={() => setWouldRecommend(true)}
//               >
//                 Yes, I would recommend
//               </button>
//               <button
//                 type="button"
//                 className={`recommend-btn ${wouldRecommend === false ? 'selected' : ''}`}
//                 onClick={() => setWouldRecommend(false)}
//               >
//                 No, I would not recommend
//               </button>
//             </div>
//           </div>

//           {/* Review Text */}
//           <div className="review-text-section">
//             <h3>Additional Comments (Optional)</h3>
//             <textarea
//               value={review}
//               onChange={(e) => setReview(e.target.value)}
//               placeholder="Share your experience with this lawyer..."
//               rows={4}
//               maxLength={500}
//             />
//             <span className="character-count">{review.length}/500</span>
//           </div>

//           {/* Anonymous Option */}
//           <div className="anonymous-section">
//             <label className="anonymous-checkbox">
//               <input
//                 type="checkbox"
//                 checked={isAnonymous}
//                 onChange={(e) => setIsAnonymous(e.target.checked)}
//               />
//               <span className="checkmark"></span>
//               Submit review anonymously
//             </label>
//           </div>
//         </div>

//         <div className="review-modal-footer">
//           <button
//             type="button"
//             className="cancel-btn"
//             onClick={handleClose}
//             disabled={isSubmitting}
//           >
//             Skip
//           </button>
//           <button
//             type="button"
//             className="submit-btn"
//             onClick={handleSubmit}
//             disabled={isSubmitting || rating === 0}
//           >
//             {isSubmitting ? 'Submitting...' : 'Submit Review'}
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ReviewModal;


import React, { useState, useEffect } from 'react';
import './ReviewModal.css';
import { authenticatedFetch } from "../../network/api";

const ReviewModal = ({ 
  isOpen, 
  onClose, 
  onSubmit, 
  lawyerName, 
  appointmentId, 
  lawyerId, 
  clientId 
}) => {
  const [formData, setFormData] = useState({
    rating: 0,
    review: '',
    isAnonymous: false,
    consultationQuality: 0,
    communicationQuality: 0,
    professionalism: 0,
    overallExperience: 0,
    wouldRecommend: null
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errors, setErrors] = useState({});

  // Reset form when modal opens/closes
  useEffect(() => {
    if (!isOpen) {
      setFormData({
        rating: 0,
        review: '',
        isAnonymous: false,
        consultationQuality: 0,
        communicationQuality: 0,
        professionalism: 0,
        overallExperience: 0,
        wouldRecommend: null
      });
      setErrors({});
      setIsSubmitting(false);
    }
  }, [isOpen]);

  // Prevent body scroll when modal is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  const updateFormData = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
    // Clear error when user starts interacting
    if (errors[field]) {
      setErrors(prev => ({ ...prev, [field]: null }));
    }
  };

  const validateForm = () => {
    const newErrors = {};
    
    if (formData.rating === 0) {
      newErrors.rating = 'Overall rating is required';
    }
    
    if (formData.review.length > 500) {
      newErrors.review = 'Review must be less than 500 characters';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async () => {
    if (!validateForm()) {
      return;
    }

    setIsSubmitting(true);
    try {
      const reviewData = {
        appointmentId,
        lawyerId,
        clientId,
        rating: formData.rating,
        review: formData.review.trim() || null,
        isAnonymous: formData.isAnonymous,
        consultationQuality: formData.consultationQuality || null,
        communicationQuality: formData.communicationQuality || null,
        professionalism: formData.professionalism || null,
        overallExperience: formData.overallExperience || null,
        wouldRecommend: formData.wouldRecommend,
        submittedAt: new Date().toISOString()
      };

      const response = await authenticatedFetch('/api/client/submitReview', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(reviewData),
      });

      const result = await response.json();

      if (response.ok) {
        onSubmit(result);
        handleClose();
      } else {
        throw new Error(result.error || 'Failed to submit review');
      }
    } catch (error) {
      console.error('Error submitting review:', error);
      setErrors({ submit: error.message || 'Failed to submit review. Please try again.' });
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleClose = () => {
    onClose();
  };

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      handleClose();
    }
  };

  const renderStars = (value, onChange, label, error) => (
    <div className="star-rating">
      {label && <span className="star-rating-label">{label}</span>}
      <div className="stars">
        {[1, 2, 3, 4, 5].map((star) => (
          <button
            key={star}
            type="button"
            className={`star ${star <= value ? 'filled' : ''}`}
            onClick={() => onChange(star)}
            aria-label={`Rate ${star} star${star !== 1 ? 's' : ''}`}
          >
            ★
          </button>
        ))}
      </div>
      {error && <span className="error-message">{error}</span>}
    </div>
  );

  const StarIcon = () => (
    <svg viewBox="0 0 24 24" fill="currentColor">
      <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
    </svg>
  );

  if (!isOpen) return null;

  const isFormValid = formData.rating > 0;
  const characterCount = formData.review.length;
  const isOverLimit = characterCount > 500;

  return (
    <div className="review-modal-overlay" onClick={handleOverlayClick}>
      <div className="review-modal" role="dialog" aria-labelledby="review-modal-title">
        <div className="review-modal-scroll">
          <div className="review-modal-header">
            <div className="icon">
              <StarIcon />
            </div>
            <h2 id="review-modal-title">Rate Your Consultation</h2>
            <p>
              How was your consultation with{' '}
              <span className="lawyer-name">{lawyerName}</span>?
            </p>
          </div>

          <div className="review-modal-content">
            {/* Overall Rating */}
            <div className="section">
              <h3>Overall Rating</h3>
              {renderStars(
                formData.rating, 
                (value) => updateFormData('rating', value),
                '',
                errors.rating
              )}
              <p style={{ color: '#64748b', fontSize: '14px', marginTop: '12px' }}>
                How would you rate your overall experience?
              </p>
            </div>

            {/* Detailed Ratings */}
            <div className="section">
              <h3>Detailed Feedback</h3>
              <p style={{ color: '#64748b', fontSize: '14px', marginBottom: '20px' }}>
                Help others by rating specific aspects of your consultation
              </p>
              
              {renderStars(
                formData.consultationQuality,
                (value) => updateFormData('consultationQuality', value),
                'Quality of Legal Advice'
              )}
              
              {renderStars(
                formData.communicationQuality,
                (value) => updateFormData('communicationQuality', value),
                'Communication & Clarity'
              )}
              
              {renderStars(
                formData.professionalism,
                (value) => updateFormData('professionalism', value),
                'Professionalism & Courtesy'
              )}
              
              {renderStars(
                formData.overallExperience,
                (value) => updateFormData('overallExperience', value),
                'Overall Experience'
              )}
            </div>

            {/* Recommendation */}
            <div className="section recommendation">
              <h3>Recommendation</h3>
              <p style={{ color: '#64748b', fontSize: '14px', marginBottom: '20px' }}>
                Would you recommend this lawyer to others?
              </p>
              <div className="recommendation-buttons">
                <button
                  type="button"
                  className={`recommend-btn yes ${formData.wouldRecommend === true ? 'selected' : ''}`}
                  onClick={() => updateFormData('wouldRecommend', true)}
                >
                  Yes, I would recommend
                </button>
                <button
                  type="button"
                  className={`recommend-btn no ${formData.wouldRecommend === false ? 'selected' : ''}`}
                  onClick={() => updateFormData('wouldRecommend', false)}
                >
                  No, I would not recommend
                </button>
              </div>
            </div>

            {/* Review Text */}
            <div className="section review-text">
              <h3>Your Experience</h3>
              <p style={{ color: '#64748b', fontSize: '14px', marginBottom: '16px' }}>
                Share additional details about your consultation (optional)
              </p>
              <textarea
                className="review-textarea"
                value={formData.review}
                onChange={(e) => updateFormData('review', e.target.value)}
                placeholder="What went well? What could be improved? Your feedback helps other clients and lawyers improve their service..."
                rows={4}
                maxLength={500}
              />
              <span 
                className={`character-count ${isOverLimit ? 'error' : ''}`}
                style={{ color: isOverLimit ? '#ef4444' : '#64748b' }}
              >
                {characterCount}/500
              </span>
              {errors.review && <span className="error-message">{errors.review}</span>}
            </div>

            {/* Anonymous Option */}
            <div className="section anonymous">
              <h3>Privacy</h3>
              <label className="anonymous-checkbox">
                <input
                  type="checkbox"
                  checked={formData.isAnonymous}
                  onChange={(e) => updateFormData('isAnonymous', e.target.checked)}
                />
                <span className="checkmark"></span>
                Submit this review anonymously
                <div style={{ fontSize: '13px', color: '#64748b', marginTop: '4px' }}>
                  Your name won't be displayed with this review
                </div>
              </label>
            </div>

            {errors.submit && (
              <div style={{ 
                background: '#fef2f2', 
                border: '1px solid #fecaca', 
                borderRadius: '8px', 
                padding: '12px', 
                color: '#dc2626',
                fontSize: '14px',
                marginTop: '16px'
              }}>
                {errors.submit}
              </div>
            )}
          </div>
        </div>

        <div className="review-modal-footer">
          <button
            type="button"
            className="footer-btn cancel-btn"
            onClick={handleClose}
            disabled={isSubmitting}
          >
            Skip for Now
          </button>
          <button
            type="button"
            className="footer-btn submit-btn"
            onClick={handleSubmit}
            disabled={isSubmitting || !isFormValid || isOverLimit}
          >
            {isSubmitting ? (
              <>
                <span className="loading-spinner"></span>
                Submitting...
              </>
            ) : (
              'Submit Review'
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ReviewModal;